@if (currentRole) {
    <nav class="h-full z-50 bg-black text-gray-900 dark:text-gray-100 flex flex-col p-2">
    <div class="px-1 grow">
        @for (group of menuItems; track group) {
            <div class="mb-4">
                @if (hasAccess(group?.roles)) {
                    <div>
                        <div class="px-4 py-2 font-semibold uppercase text-sm dark:text-gray-400">
                            {{ group.label }}
                        </div>
                        <div class="flex flex-col gap-2 text-sm">
                            @for (item of group.items; track item) {
                                @if (hasAccess(item?.roles)) {
                                    <button
                                            (click)="navigateTo(item.routerLink)"
                                [ngClass]="{
              'cursor-not-allowed opacity-50': item.comingSoon,
              'bg-gray-200 font-bold dark:bg-gray-700 dark:font-bold': isActive(item.routerLink)
            }"
                                            [disabled]="item.comingSoon"
                                            class="flex items-center w-full text-left px-6 py-2 mb-1 hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition ease-in"
                                    >
                                        @if (item.icon) {
                                            <i [ngClass]="item.icon" class="mr-2"></i>
                                        }
                                        <p class="ml-2 truncate">{{ item.label }}</p>
                                    </button>
                                }
                            }
                        </div>
            </div>
                }
        </div>
        }
        @if (currentRole) {
            <div class="flex justify-center mb-4">
                <div class="border border-gray-300 dark:border-gray-700 px-3 py-2 rounded-sm">
                    <p class="text-xs">Current Role: {{ currentRole | roleName }}</p>
                </div>
        </div>
        }
        @if (currentRole) {
            <div class="flex justify-center mb-4">
                <p-button (click)="logout()" icon="pi pi-power-off" label="Logout" severity="secondary"
                          size="small"></p-button>
        </div>
        }
    </div>
    </nav>
}